import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSparepartImports } from '../../../actions/sparepartImports';
import SparepartImportItem from '../imports/SparepartImportItem';
import TableSpinner from '../../layout/TableSpinner';
import CustomPaginationWithManyPages from '../../layout/CustomPaginationWithManyPages';

const SparePartImports = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    
    // Extract ID from URL path manually
    const id = location.pathname.match(/\/spare-parts\/(\d+)/)?.[1];
    
    const { sparepartImport } = useSelector(state => state);
    const { 
        sparepartImports, 
        loading, 
        numberOfPages, 
        currentPage 
    } = sparepartImport;

    useEffect(() => {
        // Filter imports by spare part ID
        const filters = { sparepart_id: id };
        dispatch(getSparepartImports(1, filters));
    }, [dispatch, id]);

    const handlePageChange = (page) => {
        const filters = { sparepart_id: id };
        dispatch(getSparepartImports(page, filters));
    };

    if (loading) {
        return <TableSpinner />;
    }

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0">Ehtiyot qismi kirimlari</h5>
                </div>
                <div className="card-body p-0">
                    {sparepartImports && sparepartImports.length > 0 ? (
                        <>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col" >#</th>
                                            <th scope="col" >Ma'lumotnoma raqami</th>
                                            <th scope="col" >Sklad</th>
                                            <th scope="col" >Ehtiyot qismlar</th>
                                            <th scope="col" >Ta'minotchi</th>
                                            <th scope="col" >Umumiy summa</th>
                                            <th scope="col" >Sana</th>
                                            <th scope="col" >Amallar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sparepartImports.map((sparepartImport, index) => (
                                            <SparepartImportItem
                                                key={sparepartImport.id}
                                                sparepartImport={sparepartImport}
                                                number={(currentPage - 1) * 10 + index + 1}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            {numberOfPages > 1 && (
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <CustomPaginationWithManyPages
                                        numberOfPages={numberOfPages}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Bu ehtiyot qismi uchun hech qanday kirim topilmadi.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SparePartImports; 